/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-additional-field-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-right:20px;margin-top:5px;right:0;position:absolute;top:-28px;background:#fff}.btn-additional-field[_ngcontent-%COMP%]{border:none;color:#fff;margin:3px;border-radius:5px;cursor:pointer}.additional-field-no-padding[_ngcontent-%COMP%]     div.mat-form-field-wrapper{padding-bottom:0}.field-font-size[_ngcontent-%COMP%]{font-size:12px}.icon-display[_ngcontent-%COMP%]{font-size:17px;display:contents;color:red}.success[_ngcontent-%COMP%]{color:green}"];
export { styles as styles };
